import { BookingStates } from '../../../../../constants/booking-states';

export const shouldShowBookingDetailsBtn = (booking, isGuestView) => {
  let shouldShow = false;

  const detailsPages = [
    'review-offer',
    'review-booking-update',
    'current-details',
    'review-request'
  ];
  const onDetailsPage = detailsPages.some((p) =>
    window.location.pathname.endsWith(p)
  );
  if (onDetailsPage) {
    return shouldShow;
  }

  if (
    booking.is_system_managed &&
    [
      BookingStates.ACTIVE,
      BookingStates.REQUESTED,
      BookingStates.GUEST_UPDATE_REQUESTED,
      BookingStates.HOST_UPDATE_REQUESTED,
      BookingStates.OFFER_SUBMITTED
    ].includes(booking.obj_state)
  ) {
    shouldShow = true;
  } else if (
    isGuestView &&
    [
      BookingStates.EXPIRED,
      BookingStates.DECLINED,
      BookingStates.WITHDRAWN,
      BookingStates.CANCELLED
    ].includes(booking.obj_state)
  ) {
    shouldShow = true;
  } else if (!isGuestView && booking.obj_state === BookingStates.EXECUTED) {
    shouldShow = true;
  }

  return shouldShow;
};
